import ReactDatePicker from 'react-datepicker'
import styled from 'styled-components'
import whiteCalendarIcon from '../../assets/calendar-white.svg'
import whiteCalendarIconLarge from '../../assets/calendar-white-large.svg'
interface ContainerProps {
  className?: string
}

export const Container = styled.div<ContainerProps>`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 17px;
  border: 1px solid var(--gray-100);
  border-radius: 5px;
  width: 100%;
  max-width: 60px;
  height: 60px;
  background-color: #1D108F;
  @media (max-width: 900px) {
    width: 100%;
    max-width: 41px;
    height: 39px;
    background-color: #1D108F;
  }
`

export const CustomDate = styled(ReactDatePicker)`
  border: none;
  outline: none;
  font-weight: 500;
  @media (max-width: 900px) {
    display: none;
  }
`

export const CalendarIcon = styled(ReactDatePicker).attrs({
  className: 'CalendarIcon',
})`
  cursor: pointer;
  width: 30px;
  height: 30px;
  background-color: #1D108F;
  background-image: url(${whiteCalendarIconLarge});
  outline: none;
  border: none;
  color: transparent;

  @media (max-width: 900px) {
    width: 18px;
    height: 18px;
    background-color: #1D108F;
    background-image: url(${whiteCalendarIcon});
  }
`

export const CustomInput = styled(styled.button``)`
  width: 100px;
  height: 100px;
  background-color: red;
`
